import $ from "jquery";

function showMsg($container, text, isError) {
  $container
    .removeClass("text-red text-green")
    .addClass(isError ? "text-red" : "text-green")
    .html(text);
}

export function memberPassword() {
  const $msg = $(".member-password__msg");
  if (!$msg.length) {
    return;
  }

  const $request = $("#member-password-request");
  if ($request.length) {
    $request.on("submit", function (e) {
      e.preventDefault();
      const $form = $(this);
      const $submit = $form.find('button[type="submit"]');
      const $email = $form.find("#reset-email");
      $form.find(".member-password__error").remove();

      if (!$.trim($email.val())) {
        $('<span class="member-password__error text-base text-red text-opacity-80"></span>')
          .text("Please enter your email address")
          .insertAfter($email);
        return;
      }

      $submit.prop("disabled", true);
      $msg.empty().removeClass("text-red text-green");

      $.ajax({
        url: $form.attr("action"),
        data: $form.serialize(),
        type: "POST",
        dataType: "json",
        success: function (data) {
          const message =
            data && data.data && data.data.message
              ? data.data.message
              : "If that email address is registered, you will receive a link shortly.";
          showMsg($msg, message, false);
          $submit.prop("disabled", false);
        },
        error: function (xhr) {
          let err = "Something went wrong. Please try again.";
          if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
            err = xhr.responseJSON.data.message;
          }
          showMsg($msg, err, true);
          $submit.prop("disabled", false);
        },
      });
    });
  }

  const $reset = $("#member-password-reset");
  if ($reset.length) {
    $reset.on("submit", function (e) {
      e.preventDefault();
      const $form = $(this);
      const $submit = $form.find('button[type="submit"]');
      const $pass = $form.find("#password");
      const $confirm = $form.find("#confirm-password");
      $form.find(".member-password__error").remove();

      let ok = true;
      if (!$.trim($pass.val())) {
        $('<span class="member-password__error text-base text-red text-opacity-80"></span>')
          .text("Please enter a new password")
          .insertAfter($pass);
        ok = false;
      }
      if (!$.trim($confirm.val())) {
        $('<span class="member-password__error mt-2 text-base text-red text-opacity-80"></span>')
          .text("Please confirm your password")
          .insertAfter($confirm);
        ok = false;
      }
      if (!ok) {
        return;
      }

      $submit.prop("disabled", true);
      $msg.empty().removeClass("text-red text-green");

      $.ajax({
        url: $form.attr("action"),
        data: $form.serialize(),
        type: "POST",
        dataType: "json",
        success: function (data) {
          if (data && data.success && data.data && data.data.redirect) {
            window.location.href = data.data.redirect;
            return;
          }
          const message =
            data && data.data && data.data.message
              ? data.data.message
              : "Your password has been reset.";
          showMsg($msg, message, false);
          $submit.prop("disabled", false);
        },
        error: function (xhr) {
          let err = "Something went wrong. Please try again.";
          if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
            err = xhr.responseJSON.data.message;
          }
          showMsg($msg, err, true);
          $submit.prop("disabled", false);
        },
      });
    });
  }
}
